import APIService from 'services/APIService'

const api = APIService()

export const getEmailsList = ({ bpId, page = 1, perPage = 20 }) =>
  api.get(`/building-passport/${bpId}/emails`, {
    params: {
      page,
      per_page: perPage
    }
  })

export const getEmailStats = ({ bpId }) =>
  api.get(`/building-passport/${bpId}/emails/stats`)

export const markEmailAsRead = ({ bpId, emailId }) =>
  api.post(`/building-passport/${bpId}/emails/${emailId}/mark-as-read`)

export const getEmailDetails = ({ bpId, emailId }) =>
  api.get(`/building-passport/${bpId}/emails/${emailId}`)

export const retryEmailAttachments = ({ bpId, emailId }) =>
  api.post(`/building-passport/${bpId}/emails/${emailId}/retry-attachments`)

export const retryEmailAttachment = ({ bpId, emailId, attachmentId }) =>
  api.post(`/building-passport/${bpId}/emails/${emailId}/attachments/${attachmentId}/retry`)